[...document.querySelectorAll('.teaser-image--link:not([href])')].forEach((teaser) => {
    const elementWithHref = teaser.querySelector('[href]');
    if (!elementWithHref) {
        return;
    }

    const href = elementWithHref.getAttribute('href');
    if (href) {
        teaser.addEventListener('click', (event) => {
            if (href === window.location.href) {
                e.preventDefault();
            } else {
                window.location.href = href;
            }
        });
    }
});
